import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--tabbar"
export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam) {
      const activeTabs = document.querySelectorAll(".active");
      activeTabs.forEach((tab) => {
        tab.classList.remove("active");
        if (tab.classList.contains("tab-pane")) {
          tab.classList.add("hidden");
        }
      });

      const tabLink = document.querySelector(`a[href="#${tabParam}"]`);
      if (tabLink) {
        tabLink.parentElement.classList.add("active");
        const targetPane = document.getElementById(tabParam);
        if (targetPane) {
          targetPane.classList.add("active");
          targetPane.classList.remove("hidden");
        }
      }
    }
  }

  onClickChangeTab(event) {
    event.preventDefault();
    const activeTabs = document.querySelectorAll(".active");

    activeTabs.forEach((tab) => {
      tab.classList.remove("active");
      if (tab.classList.contains("tab-pane")) {
        tab.classList.add("hidden");
      }
    });

    event.target.parentElement.classList.add("active");
    const tabId = event.target.href.split("#")[1];
    const targetPane = document.getElementById(tabId);
    if (targetPane) {
      targetPane.classList.add("active");
      targetPane.classList.remove("hidden");
    }

    const url = new URL(window.location);
    url.searchParams.set("tab", tabId);
    window.history.pushState({}, "", url);
  }
}
